import { isRegistrationAvailable } from "../../../../../../utils/timer";
import { useControllerContext } from "../../../../hooks/controller-context";
import { ControllerTab } from "../../../../hooks/use-controller-tab";
import { MobileControllerBottomWrapper } from "../../style";

const MobileTimerControllerBottom = () => {
  const { isControllerTab, setControllerTab, data } = useControllerContext();

  const tabs = [
    { name: "클락 리모컨", value: ControllerTab.TOURNAMENT },
    { name: "싯인 관리", value: ControllerTab.SIT_IN },
    { name: "시상", value: ControllerTab.PRIZE },
  ];

  const handlePointPaid = () => {
    if (!data) return;

    const isRegistration = isRegistrationAvailable(data);

    if (isRegistration) {
      alert("레지마감레벨 이후 시상이 가능합니다. ");
      return;
    }
    setControllerTab(ControllerTab.PRIZE);
  };

  return (
    <MobileControllerBottomWrapper>
      {tabs.map((tab, i) => (
        <div
          onClick={() =>
            tab.value === ControllerTab.PRIZE
              ? handlePointPaid()
              : setControllerTab(tab.value)
          }
          key={i}
          className={`item ${
            tab.value && isControllerTab(tab.value) ? "selected" : ""
          }`}
        >
          {tab.name}
        </div>
      ))}
    </MobileControllerBottomWrapper>
  );
};
export default MobileTimerControllerBottom;
